export const name = 'gzConfirmDialogController';
export default function gzConfirmDialogController(
  // Controller angular dependencies
  $mdDialog
) {
  'ngInject';
  // Constants

  // Variables

  // View Model
  let vm = this;
  //   VM properties
  //   VM methods
  vm.submit = submit;

  onInit();
  return;

  ///////////////
  // Init
  function onInit() {
  }

  ///////////////
  // VM methods
  function submit() {
    $mdDialog.hide(true);
  }

  ///////////////
  // Helpers
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/confirm/confirm-dialog.controller.js